const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
export const FOOTER_API_BASE = `${ENV_API_BASE_URL}/api/footer`;
export const FOOTER_ASSET_BASE = `${ENV_API_BASE_URL}`;

export const FOOTER_FALLBACK = {
  aboutText:
    "Hatha Yog Ashram, founded in 2017 in Rishikesh, India, is one of the most trusted yoga teacher training schools. We offer traditional Hatha, Ashtanga, Kundalini, Meditation and Pranayama practices rooted in ancient yogic wisdom.",
  primaryLogoUrl: "",
  secondaryLogoUrl: "",
  trustText: "YogAshram Trust.",
  linkSections: [
    {
      title: "Quick Links",
      links: [
        { label: "Home", path: "/" },
        { label: "About Us", path: "/about-us" },
        { label: "Our Teachers", path: "/teachers" },
        { label: "Gallery", path: "/gallery" },
        { label: "Blog", path: "/blog" },
        { label: "Contact Us", path: "/contact-us" },
      ],
    },
    {
      title: "Kundalini Yoga",
      links: [
        { label: "100 Hour", path: "/kundalini-100" },
        { label: "200 Hour", path: "/kundalini-200" },
        { label: "300 Hour", path: "/kundalini-300" },
      ],
    },
    {
      title: "Yoga Courses",
      links: [
        { label: "Yin Yoga", path: "/YinYoga" },
        { label: "Vedic Mantra", path: "/vedic-mantra" },
        { label: "100 Hour TTC", path: "/course/100-hour-yttc" },
        { label: "200 Hour TTC", path: "/course/200-hour-yttc" },
        { label: "300 Hour TTC", path: "/course/300-hour-yttc" },
        { label: "500 Hour TTC", path: "/course/500-hour-yttc" },
      ],
    },
    {
      title: "Yoga Retreats",
      links: [
        { label: "Yoga Retreat", path: "/meditation-retreat" },
        { label: "5 Days", path: "/5-days-yoga-retreat" },
        { label: "10 Days", path: "/10-days-yoga-retreat" },
        { label: "20 Days", path: "/20-days-yoga-retreat" },
      ],
    },
  ],
  contactTitle: "Contact",
  contactItems: [
    { type: "location", value: "Upper Tapovan", href: "" },
    { type: "phone", value: "+91 9335606336", href: "" },
    { type: "email", value: "info@hathayogashram.com", href: "" },
    { type: "clock", value: "7AM - 7PM", href: "" },
  ],
  socialLinks: [
    {
      platform: "facebook",
      url: "https://www.facebook.com/profile.php?id=100095297992781",
    },
    {
      platform: "instagram",
      url: "https://www.instagram.com/hathayogashram/",
    },
    {
      platform: "youtube",
      url: "https://www.youtube.com/",
    },
  ],
  keywords: [
    "Yoga School in Rishikesh",
    "Best Yoga Teacher Training India",
    "200 Hour Yoga TTC",
    "300 Hour Yoga TTC",
    "Yoga Retreats in India",
    "Kundalini Awakening",
    "Meditation Retreats",
  ],
  copyrightText:
    "Hatha Yog Ashram | Coming under Yog Ashram | All Rights Reserved.",
};

const cloneLinks = (links = []) => links.map((link) => ({ ...link }));
const cloneSections = (sections = []) =>
  sections.map((section) => ({
    ...section,
    links: cloneLinks(section.links),
  }));

export const createFooterForm = () => ({
  aboutText: FOOTER_FALLBACK.aboutText,
  primaryLogoUrl: FOOTER_FALLBACK.primaryLogoUrl,
  secondaryLogoUrl: FOOTER_FALLBACK.secondaryLogoUrl,
  primaryLogoFile: null,
  secondaryLogoFile: null,
  trustText: FOOTER_FALLBACK.trustText,
  linkSections: cloneSections(FOOTER_FALLBACK.linkSections),
  contactTitle: FOOTER_FALLBACK.contactTitle,
  contactItems: FOOTER_FALLBACK.contactItems.map((item) => ({ ...item })),
  socialLinks: FOOTER_FALLBACK.socialLinks.map((item) => ({ ...item })),
  keywordsText: FOOTER_FALLBACK.keywords.join("\n"),
  copyrightText: FOOTER_FALLBACK.copyrightText,
});

export const normalizeFooterData = (data) => {
  const defaults = createFooterForm();
  if (!data) return defaults;

  return {
    aboutText: data.aboutText || defaults.aboutText,
    primaryLogoUrl: data.primaryLogoUrl || defaults.primaryLogoUrl,
    secondaryLogoUrl: data.secondaryLogoUrl || defaults.secondaryLogoUrl,
    primaryLogoFile: null,
    secondaryLogoFile: null,
    trustText: data.trustText || defaults.trustText,
    linkSections:
      Array.isArray(data.linkSections) && data.linkSections.length > 0
        ? cloneSections(data.linkSections)
        : defaults.linkSections,
    contactTitle: data.contactTitle || defaults.contactTitle,
    contactItems:
      Array.isArray(data.contactItems) && data.contactItems.length > 0
        ? data.contactItems.map((item) => ({
            type: item.type || "custom",
            value: item.value || "",
            href: item.href || "",
          }))
        : defaults.contactItems,
    socialLinks:
      Array.isArray(data.socialLinks) && data.socialLinks.length > 0
        ? data.socialLinks.map((item) => ({
            platform: item.platform || "custom",
            url: item.url || "",
          }))
        : defaults.socialLinks,
    keywordsText:
      Array.isArray(data.keywords) && data.keywords.length > 0
        ? data.keywords.join("\n")
        : defaults.keywordsText,
    copyrightText: data.copyrightText || defaults.copyrightText,
  };
};

export const normalizeFooterContent = (data) => {
  const source = data || {};

  return {
    ...FOOTER_FALLBACK,
    ...source,
    linkSections:
      Array.isArray(source.linkSections) && source.linkSections.length > 0
        ? cloneSections(source.linkSections)
        : cloneSections(FOOTER_FALLBACK.linkSections),
    contactItems:
      Array.isArray(source.contactItems) && source.contactItems.length > 0
        ? source.contactItems.map((item) => ({
            type: item.type || "custom",
            value: item.value || "",
            href: item.href || "",
          }))
        : FOOTER_FALLBACK.contactItems.map((item) => ({ ...item })),
    socialLinks:
      Array.isArray(source.socialLinks) && source.socialLinks.length > 0
        ? source.socialLinks.map((item) => ({
            platform: item.platform || "custom",
            url: item.url || "",
          }))
        : FOOTER_FALLBACK.socialLinks.map((item) => ({ ...item })),
    keywords:
      Array.isArray(source.keywords) && source.keywords.length > 0
        ? [...source.keywords]
        : [...FOOTER_FALLBACK.keywords],
  };
};

export const toFooterAssetUrl = (value) => {
  if (!value) return "";
  if (value.startsWith("http") || value.startsWith("data:")) return value;
  return `${FOOTER_ASSET_BASE}/${value.replace(/^\/+/, "")}`;
};
